import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { OposicionesNavbar } from '@/components/oposiciones/OposicionesNavbar';
import { PlanRedirect } from '@/components/routing/PlanRedirect';
import { Sidebar } from '@/components/sidebar/Sidebar';
import { MobileSidebarDrawer } from '@/components/sidebar/MobileSidebarDrawer';
import { UserMenuButton } from '@/components/chat/UserMenuButton';
import { GlobalGenerationManager } from '@/components/oposiciones/GlobalGenerationManager';
import { GenerationReadyNotifier } from '@/components/notifications/GenerationReadyNotifier';
import { prefetchArea } from '@/lib/routePrefetch';

export function OposicionesLayout() {
  const location = useLocation();
  const isChatRoute = location.pathname.startsWith('/app/oposiciones/chat');

  useEffect(() => { prefetchArea('oposiciones'); }, []);

  return (
    <div className="flex flex-col h-screen bg-background">
      <PlanRedirect />
      <GenerationReadyNotifier />
      <GlobalGenerationManager />
      <OposicionesNavbar />
      <div className="flex-1 flex overflow-hidden min-w-0">
        {isChatRoute && (
          <div className="hidden md:block oposiciones-sidebar">
            <Sidebar variant="oposiciones" />
          </div>
        )}
        <main className="flex-1 flex flex-col overflow-hidden min-w-0">
          {isChatRoute && (
            <div className="md:hidden flex items-center justify-between gap-3 border-b border-border bg-card px-2 py-2 shrink-0 oposiciones-sidebar">
              <div className="flex items-center gap-2 min-w-0">
                <MobileSidebarDrawer variant="oposiciones" triggerClassName="" />
                <span className="text-sm font-semibold truncate">Conversaciones</span>
              </div>
              <UserMenuButton variant="oposiciones" />
            </div>
          )}
          <Outlet />
        </main>
      </div>
    </div>
  );
}
